import React from "react";

import Heading from "components/heading";
import Image from "next/image";
import CultureIcon from "public/images/icons/enerflo-culture-icon.svg";
import TeamIcon from "public/images/icons/enerflo-team-icon.svg";

import HeroSection from "../../hero-section";

const items = [
  {
    title: "Our Team",
    description: (
      <span className="space-y-4">
        <span className="block">
          Enerflo growth has been feasible because of our incredible team. They are the Rare Elite. They find a need,
          build audaciously and always, always, put the customer first. Since day one, we’ve strived to find the best of
          the best.
        </span>
        <span className="block">
          As we continue to grow, we’re always looking for new talent to share in our passion and bring their best
          selves to work every day.
        </span>
      </span>
    ),
    image: TeamIcon,
    imageAlt: "Icon - Enerflo Team",
  },
  {
    title: "Our Culture",
    description: (
      <span className="space-y-4">
        <span className="block">
          Build Audaciously. Different by Design. Partner Success. Profound Impact. These aren’t just buzzwords. These
          are tenets we live by. We also believe in humor, dedication, fun, laughter, drive, family, audacity, passion,
          humility, innovation, get stuff done, think outside the box, support, all ideas welcome, friendship, bring
          your authentic self, no doors policy, teamwork!
        </span>
        <span className="block">
          As a fully distributed workforce in a digital world, we know the importance of connection and find creative
          ways to keep our employees engaged, heard and connected, regardless of where they live.
        </span>
      </span>
    ),
    image: CultureIcon,
    imageAlt: "Icon - Enerflo Culture",
  },
];

const title = "Why Enerflo?";

const WhyEnerflo = () => (
  <div className="bg-gray-100">
    <HeroSection title={title}>
      <HeroSection.Content>
        <HeroSection.Header>
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <p className="text-lg text-gray-500 mx-auto md:w-3/4 lg:w-2/3 md:text-center">
          “Enerflo” stands for “Energy-flow”... or basically the energy consumption or production of a home. Our
          homegrown, purpose-built tech is designed by industry experts for industry professionals, fueling the growth
          of the solar industry in the US and beyond. With only 3% residential solar penetration, there’s a lot of work
          to be done.
        </p>

        <div className="flex flex-col space-y-4 md:space-y-0 md:space-x-4 lg:space-x-6 mt-8 md:mt-20 md:flex-row">
          {items.map(item => (
            <div
              key={item.title}
              className="flex-1 rounded-lg shadow-lg border-2 border-primary p-4 md:py-8 text-center bg-white"
            >
              <figure className="flex items-center justify-center h-14 w-14 md:h-20 md:w-20 mx-auto">
                <Image src={item.image} alt={item.imageAlt} />
              </figure>
              <Heading tag="h5" className="mt-3 md:mt-6">
                {item.title}
              </Heading>
              <p className="mt-2 text-gray-500 text-base">{item.description}</p>
            </div>
          ))}
        </div>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default WhyEnerflo;
